import { Image } from "primereact/image";
import toneVoiceIcon from "assets/icons/icon_tone_of_voice.svg";

export const TemplateDropdown = ({ option }: { option: any }) => {
  return (
    <div className="flex-container align-center justify-start">
      <Image src={toneVoiceIcon} className="margin-right-8" />
      <span>{option.name}</span>
    </div>
  );
};
